<template>
  <div class="game-foot">
    <div>Copy Right Coin Switch Technology</div>
    <div>All rights reserved</div>
    <div>© 2017–2023</div>
  </div>
</template>

<script>
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
export default {
  methods: {},
};
</script>

<style lang="scss" scoped>
.game-foot {
  text-align: center;
  font-size: 0.36rem;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 40px;
  margin: auto;
  color: rgb(245, 247, 243);
}
</style>